"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsignmentAttachmentTemplateSchema = exports.ScanHistoryDocumentSchema = exports.EnvdDocumentSchema = exports.FarmerSchema = exports.AddressSchema = exports.SecurityCodeDocumentSchema = void 0;
const zod_1 = require("zod");
const token_1 = require("../misc/token");
const consignment_1 = require("../misc/consignment");
exports.SecurityCodeDocumentSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.literal("code"),
    userId: zod_1.z.string(),
    details: zod_1.z.object({
        used: zod_1.z.boolean(),
        codes: zod_1.z.array(zod_1.z.string()),
        product: zod_1.z.object({
            container: zod_1.z.literal("item"),
            product: token_1.ExternalIdsSchema,
            showDeliveryHistory: zod_1.z.boolean(),
            showMap: zod_1.z.boolean(),
            isConfidential: zod_1.z.boolean(),
            date: zod_1.z.string(),
            source: zod_1.z.object({
                companyName: zod_1.z.string(),
                companyNumber: zod_1.z.string(),
                creatorEmail: zod_1.z.string()
            })
        })
    }),
    createdAt: zod_1.z.date()
});
exports.AddressSchema = zod_1.z.object({
    line1: zod_1.z.string(),
    postcode: zod_1.z.string(),
    state: zod_1.z.string(),
    town: zod_1.z.string()
});
exports.FarmerSchema = zod_1.z.object({
    name: zod_1.z.string(),
    pic: zod_1.z.string(),
    address: exports.AddressSchema
});
exports.EnvdDocumentSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.literal("eNVD"),
    userId: zod_1.z.string(),
    details: zod_1.z.object({
        consignment: zod_1.z.object({
            owner: exports.FarmerSchema,
            consignee: exports.FarmerSchema,
            declaration: zod_1.z.object({
                fullname: zod_1.z.string(),
                address: exports.AddressSchema,
                accept: zod_1.z.boolean(),
                date: zod_1.z.string(),
                phone: zod_1.z.string(),
                email: zod_1.z.string(),
                signature: zod_1.z.string()
            }),
            Programs: zod_1.z.array(zod_1.z.string()),
            VendorTrackingCode: zod_1.z.string(),
            ReferenceNumber: zod_1.z.string()
        }),
        programs: zod_1.z.array(zod_1.z.string()),
        answers: zod_1.z.array(zod_1.z.object({
            questionId: zod_1.z.string(),
            index: zod_1.z.string().nullable(),
            value: zod_1.z.string()
        })),
        filledNlis: zod_1.z.object({
            animal: zod_1.z.string(),
            username: zod_1.z.string(),
            password: zod_1.z.string(),
            email: zod_1.z.string(),
            data: zod_1.z.object({
                rfid: zod_1.z.array(zod_1.z.string())
            })
        }).optional(),
        consignmentNumber: zod_1.z.string(),
        eNVDS3Link: zod_1.z.string(),
        forms: zod_1.z.array(zod_1.z.object({
            type: zod_1.z.string(),
            serialNumber: zod_1.z.string()
        })),
        submittedQuery: zod_1.z.string()
    }),
    createdAt: zod_1.z.date()
});
exports.ScanHistoryDocumentSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.literal("scanHistory"),
    externalIds: token_1.ExternalIdsSchema,
    details: zod_1.z.object({
        web: zod_1.z.object({
            count: zod_1.z.number(),
            history: zod_1.z.array(zod_1.z.date())
        }),
        consumer: zod_1.z.object({
            count: zod_1.z.number(),
            history: zod_1.z.array(zod_1.z.date())
        }),
        supplier: zod_1.z.object({
            count: zod_1.z.number(),
            history: zod_1.z.array(zod_1.z.date())
        })
    }),
    createdAt: zod_1.z.date()
});
exports.ConsignmentAttachmentTemplateSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.literal("template"),
    formType: consignment_1.FormTypeSchema,
    status: zod_1.z.enum(["active", "obsolete"]),
    details: zod_1.z.object({
        name: zod_1.z.string(),
        answers: zod_1.z.array(consignment_1.FormAnswerSchema)
    }),
    userId: zod_1.z.string(),
    businessId: zod_1.z.string(),
    createdAt: zod_1.z.date().optional()
});
